import Grid from '@mui/material/Grid';
import { BenefitDTO, BenefitDTOBenefitEnum, CouponsV2BenefitDetailsDTO, GiftsBenefitDetailsDTO } from 'probonio-shared-ui/api';
import React from 'react';
import { AdditionalBenefitListItemsExtensionInterface } from '../../../extension/interface/additional-benefit-list-items.extension.interface';
import { GiftStack, GiftStackItem } from '../../benefit/GiftStack';

export class GiftsAdditionalItemsExtension extends AdditionalBenefitListItemsExtensionInterface {
  showAtTop = true;

  getAdditionalItems(activeBenefits: BenefitDTO[]): React.ReactNode[] {
    const items: GiftStackItem[] = [];
    const v2GiftDetails = activeBenefits?.find(b => b.benefit === BenefitDTOBenefitEnum.CouponsV2)?.details as CouponsV2BenefitDetailsDTO;
    const giftDetails = activeBenefits?.find(b => b.benefit === BenefitDTOBenefitEnum.Gifts)?.details as GiftsBenefitDetailsDTO;

    v2GiftDetails?.availableGifts?.forEach(g => items.push({ kind: 'v2', key: g.couponGiftId, gift: g }));
    giftDetails?.gifts?.forEach(g => items.push({ kind: 'v1', key: g.couponGiftId, gift: g }));

    return items.length > 0
      ? [
          <Grid key="gifts-stack">
            <GiftStack items={items} />
          </Grid>,
        ]
      : [];
  }
}
